export const PartnerHelper = {
    Partner: {
        Shipsmart: 0,
        Correios: 1,
        TotalExpress: 2,
    }
}